import * as Yup from "yup";

export const changePasswordSchema = Yup.object({
  new_password: Yup.string().min(6).required("Please enter password"),
  confirmPassword: Yup.string()
    .required()
    .oneOf([Yup.ref("new_password"), null], "Password must match"),
});
